<template>
  <div class="header-title">
    <div class="title">{{ title }}</div>
    <div class="text">{{ text }}</div>
  </div>
</template>
<script >
export default {
  name: 'Home',
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    }
  }
}
</script>
<style scoped>
.header-title {
  text-align: center;
}
.title {
  margin-top: 24px;
  height: 18px;
  font-weight: 700;
  font-size: 18px;
  color: #3D3D3D;
  line-height: 18px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.text {
  margin-top: 13px;
  height: 14px;
  font-weight: 500;
  font-size: 14px;
  color: #3D3D3D;
  line-height: 14px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
</style>
